document.addEventListener('DOMContentLoaded', function() {
    const $body = document.body;

    const $subMenuArea = document.querySelectorAll('.site-header__main-nav__sub-menu-area');
    const $searchTriggers = document.querySelectorAll('.search-trigger');
    const $searchArea = document.getElementById('header-search');
    const $slideMenu = document.getElementById('header-main-menu');
    const $announcementBar = document.querySelector('[data-announcement-bar]');

    if ($announcementBar) {
        const announcementBarKey = `announcement-bar-dismissed-${$announcementBar.getAttribute('data-announcement-bar-key')}`;
        const $announcementBarClose = $announcementBar.querySelector('[data-announcement-bar-close]');
        const $announcementBarHeader = $announcementBar.closest('header');
        let announcementBarResizeObserver = null;

        const setAnnouncementBarHeight = () => {
            if (!$announcementBarHeader) {
                return;
            }

            const height = $announcementBar.isConnected
                ? $announcementBar.getBoundingClientRect().height
                : 0;

            $announcementBarHeader.style.setProperty('--config-site-header-announcement-bar-height', `${height}px`);
        };

        const removeAnnouncementBar = () => {
            if (announcementBarResizeObserver) {
                announcementBarResizeObserver.disconnect();
            } else {
                window.removeEventListener('resize', setAnnouncementBarHeight);
            }

            $announcementBar.remove();
            setAnnouncementBarHeight();
        };

        setAnnouncementBarHeight();

        if ('ResizeObserver' in window) {
            announcementBarResizeObserver = new ResizeObserver(setAnnouncementBarHeight);
            announcementBarResizeObserver.observe($announcementBar);
        } else {
            window.addEventListener('resize', setAnnouncementBarHeight);
        }

        try {
            if (window.sessionStorage.getItem(announcementBarKey) === 'true') {
                removeAnnouncementBar();
            }
        } catch (e) {
            // Ignore storage failures so the announcement bar still works.
        }

        if ($announcementBarClose) {
            $announcementBarClose.addEventListener('click', function() {
                try {
                    window.sessionStorage.setItem(announcementBarKey, 'true');
                } catch (e) {
                    // Ignore storage failures; the current click should still hide it.
                }

                removeAnnouncementBar();
            });
        }
    }

    if ($slideMenu) {
        const closeAllSlideMenus = () => {
            $slideMenu.querySelectorAll('[data-menu-level].active').forEach(($menuLevel) => {
                $menuLevel.classList.remove('active');
            });

            $slideMenu.querySelectorAll('[data-menu-trigger][aria-expanded="true"]').forEach(($trigger) => {
                $trigger.setAttribute('aria-expanded', 'false');
            });
        };

        $slideMenu.querySelectorAll('[data-menu-trigger]').forEach(($trigger) => {
            $trigger.addEventListener('click', function() {
                const targetLevel = $trigger.getAttribute('data-menu-trigger');
                const $targetMenu = $slideMenu.querySelector(`[data-menu-level="${targetLevel}"]`);

                if (!$targetMenu) {
                    return;
                }

                $targetMenu.classList.add('active');
                $trigger.setAttribute('aria-expanded', 'true');
            });
        });

        $slideMenu.querySelectorAll('[data-menu-back]').forEach(($backButton) => {
            $backButton.addEventListener('click', function() {
                const $currentMenu = $backButton.closest('[data-menu-level]');

                if (!$currentMenu) {
                    return;
                }

                $currentMenu.classList.remove('active');

                const currentLevel = $currentMenu.getAttribute('data-menu-level');
                const $trigger = $slideMenu.querySelector(`[data-menu-trigger="${currentLevel}"]`);

                if ($trigger) {
                    $trigger.setAttribute('aria-expanded', 'false');
                }
            });
        });

        $slideMenu.querySelectorAll('[data-ec-dismiss="offcanvas"]').forEach(($dismiss) => {
            $dismiss.addEventListener('click', closeAllSlideMenus);
        });

        document.addEventListener('click', function(e) {
            const $backdrop = e.target.closest('.offcanvas-backdrop');

            if ($backdrop && $slideMenu.classList.contains('show')) {
                closeAllSlideMenus();
            }
        });
    }

    $subMenuArea.forEach($subMenu => {
        const $targetLink = $subMenu.previousElementSibling;

        $subMenu.addEventListener('click', function(e) {
            e.stopPropagation();
        });

        if($targetLink) {
            $targetLink.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                $searchArea.classList.remove('show');

                $searchTriggers.forEach($searchTrigger => {
                    $searchTrigger.classList.remove('active');
                });

                $targetLink.classList.toggle('active');
            });

            $body.addEventListener('click', function(e) {
                $targetLink.classList.remove('active');
                $searchArea.classList.remove('show');

                $searchTriggers.forEach($searchTrigger => {
                    $searchTrigger.classList.remove('active');
                });
            });
        }
    });

    if($searchArea) {
        const $searchAreaInput = $searchArea.querySelector('.search-input');

        $searchArea.addEventListener('click', function(e) {
            if (!e.target.closest('#button-search')) {
                e.preventDefault();
            }

            e.stopPropagation();
        });

        $searchTriggers.forEach($searchTrigger => {
            $searchTrigger.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                $subMenuArea.forEach($subMenu => {
                    const $targetLink = $subMenu.previousElementSibling;

                    if($targetLink) {
                        $targetLink.classList.remove('active');
                    }
                });

                if($searchTrigger.classList.contains('active')) {
                    $searchArea.classList.remove('show');
                }
                else {
                    $searchArea.classList.add('show');
                    $searchAreaInput.focus();
                }

                $searchTrigger.classList.toggle('active');
            });
        });
    }
});
